import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const RailListContainer = styled.div<React.CSSProperties>``;

export default withAnimation(RailListContainer);
